import type { IFilterQuery } from '@shared';
import type {
  IAdsCategoryPageableResponseData,
  IAdsCategory,
} from '@shared/ads-category';

const ENDPOINT_PREFIX = 'ads-category';

export const useAdsCategoryStore = defineStore('ads-category', () => {
  const apiClient = useApiClient();
  const adsCategories = ref<IAdsCategory[]>([]);
  const adsCategory = ref<IAdsCategory | null>(null);
  const { setItem, getItem } = useLocalStorage();

  const filter = async (payload?: IFilterQuery) => {
    if (!payload) payload = { page: 1, limit: 1000 };
    const result = await apiClient.post<
      IFilterQuery,
      IAdsCategoryPageableResponseData
    >(ENDPOINT_PREFIX + '/filter', payload);
    if (result.success)
      adsCategories.value = result.data?.data as IAdsCategory[];
    return result;
  };

  const setCategory = (cat: IAdsCategory) => {
      setItem('adsCategory', cat);
      adsCategory.value = cat;
      return cat;
  };

  const initCategory = () => {
      adsCategory.value = getItem('adsCategory');
  };


  return {
    filter,
    adsCategories,
    initCategory,
    setCategory,
    adsCategory,
  };
});
